import { MOCK_DATA } from "../data/mockData";
import { ESTABLISHMENT_STATUS } from "../constants/establishmentStatus";
import { useIncidentKpi } from "../pages/tickets/hooks/useIncidents";

export function useSidebarBadges() {
  const { openTotal: tickets } = useIncidentKpi();
  const etab = MOCK_DATA.etablissements.filter((e) =>
    [ESTABLISHMENT_STATUS.WAITING_FOR_APPROVAL, ESTABLISHMENT_STATUS.MISSING_INFORMATIONS].includes(e.statut)
  ).length;
  const resa = MOCK_DATA.reservations.filter((r) => r.statut === "Remboursement demandé").length;
  return { etab, resa, tickets };
}

export default useSidebarBadges;
